var _defs, _g, _g2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontscreenballoons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2011.31 3287.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #87c771;\n      }\n\n      .cls-2 {\n        fill: #fbbd08;\n      }\n\n      .cls-3 {\n        fill: #db4d59;\n      }\n\n      .cls-4 {\n        fill: #f5717e;\n      }\n\n      .cls-5 {\n        fill: #f7f2d7;\n      }\n\n      .cls-6 {\n        fill: #454255;\n      }\n\n      .cls-7 {\n        fill: #b74954;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M901.73,1022.06c-339.36-53.48-599.26-579.24-328.98-890.63,204.69-234.82,653.88-152.24,737.99,225.82,14.12,63.47,15.6,129.08,6.65,193.48-33.33,239.92-145.64,391.81-330.57,462.74l35.51,88.57-148.29,8.37,27.7-88.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M739.8,145.8c-19.8,98.13-57.03,188.79-118.48,269.07-25.56,29.57-72.47,5.45-83.67-39.83-2.42-9.81-2.59-20.03-1.36-30.06,15.18-123.95,62.99-194.23,132.19-229.32,12.53-6.35,26.51-9.63,40.5-8.43,17.2,1.47,35.77,9.51,30.82,38.57Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 950.71,
    y: 1106.43,
    width: 16.09,
    height: 1547.11,
    transform: "translate(-43.65 22.91) rotate(-1.34)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1407.07,1714.79c-240.45-180.35-226.01-693.28,110.49-823.29,254.43-97.69,567.87,150.15,478.03,476.88-15.08,54.85-40.82,106.17-74.12,152.3-124.05,171.83-273.09,243.25-445.11,222.33l-8.83,83.02-118.07-54.28,57.6-56.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1640.82,971.04c-55.51,67.75-121.42,122.59-201.82,159.48-31.87,12.39-58.26-25.47-48.37-65.07,2.14-8.57,6.2-16.55,11.26-23.79,62.51-89.6,128.26-124.36,196.13-123.14,12.29.22,24.44,3.42,34.76,10.08,12.69,8.18,23.76,22.01,8.03,42.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1000.83,2657.15l-14.16-7.62c139.58-259.33,263.19-530.12,382.73-791.99,9.7-21.24,19.33-42.35,28.92-63.32l14.63,6.69c-9.58,20.97-19.22,42.08-28.91,63.31-119.65,262.11-243.38,533.14-383.21,792.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1150.46,1432.34c-308.89-150.38-403.69-729.16-54.16-947.9,264.41-164.7,669.82,45.62,639.7,431.75-5.06,64.83-22.83,127.99-50.22,186.97-102.03,219.69-253.84,332.1-451.44,345.85l8.06,95.08-144.26-35.36,52.32-76.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1251.84,547.04c-47.63,88.05-109.74,163.86-191.99,222.66-33.09,20.81-70.9-15.98-68.36-62.56.55-10.09,3.38-19.91,7.48-29.14,50.77-114.09,117.03-167.33,193.47-180.64,13.84-2.41,28.17-1.45,41.2,3.78,16.02,6.44,31.43,19.56,18.2,45.9Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 508.62,
    y: 2084.34,
    width: 1145.29,
    height: 16.09,
    transform: "translate(-1158.12 2822) rotate(-80.72)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M584.38,1611.03c-342.2,30.38-721.8-416.71-535.05-784.33,141.66-277.43,597.48-306.2,770.72,40.2,29.09,58.16,46.42,121.45,53.35,186.1,25.82,240.85-46.32,415.43-208.55,529.07l55.92,77.32-141.84,44.06,5.46-92.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.88,800.16c4.57,100-9.57,196.99-49.73,289.77-17.63,34.88-68.99,22.86-90.83-18.37-4.73-8.93-7.37-18.8-8.61-28.83-15.31-123.93,14.03-203.71,72.66-254.53,10.61-9.2,23.39-15.77,37.25-17.99,17.04-2.74,37.01.56,39.25,29.95Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M973.64,2667.39c-121.19-344.79-231.49-676.09-327.83-984.7l15.35-4.79c96.29,308.43,206.52,639.55,327.65,984.16l-15.18,5.33Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M983.74,3232.37c-1.71,0-3.43-.54-4.89-1.66-3.52-2.71-4.19-7.75-1.48-11.28,127.78-166.45,94.62-257.46,56.21-362.83-18.81-51.62-38.27-105-42.95-172.43-.31-4.43,3.04-8.27,7.47-8.58,4.39-.29,8.27,3.03,8.58,7.47,4.53,65.16,23.59,117.46,42.02,168.03,40.03,109.83,74.6,204.68-58.56,378.14-1.58,2.06-3.97,3.14-6.39,3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M993.19,3287.34c-2.65,0-5.24-1.31-6.78-3.71-2.39-3.74-1.3-8.72,2.44-11.11,47.04-30.12,98.57-80.9,76.97-151.78-3.91-12.82-10.31-25.53-19.05-37.78-130.91-183.67-111.78-252.03-80.11-365.28,3.03-10.85,6.17-22.06,9.3-33.84,1.14-4.29,5.56-6.85,9.84-5.71,4.29,1.14,6.85,5.54,5.71,9.84-3.15,11.88-6.31,23.15-9.35,34.05-30.39,108.63-48.73,174.2,77.72,351.6,9.74,13.66,16.92,27.94,21.33,42.43,19.42,63.73-9.52,122.52-83.69,170.01-1.34.86-2.84,1.27-4.33,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M948.71,3137.01c-2.7,0-5.34-1.36-6.86-3.82-97.27-157.92-40.29-311,28.28-439.92,2.08-3.92,6.96-5.41,10.88-3.32,3.92,2.09,5.41,6.96,3.32,10.88-66.43,124.89-121.8,272.93-28.79,423.93,2.33,3.78,1.15,8.74-2.63,11.07-1.31.81-2.77,1.19-4.21,1.19Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 909.68,
    y: 2617.09,
    width: 162.82,
    height: 96.94,
    rx: 9.98,
    ry: 9.98
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontscreenballoons);
export default __webpack_public_path__ + "static/media/frontscreenballoons.7b557932dcbebfeba027988e154bfcec.svg";
export { ForwardRef as ReactComponent };